import { useEffect } from 'react';

import { AlertFill } from '@moniebook-web/icons/system/alert-fill';
import { CheckboxCircleFill } from '@moniebook-web/icons/system/checkbox-circle-fill';
import { Information2Fill } from '@moniebook-web/icons/system/information-2-fill';
import { ClientProvider, getItem, getTelemetry } from '@moniebook-web/utils';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { Toaster } from 'sonner';

import { config } from '@/config';
import { appRoutes } from '@/routes/index';

import { ErrorBoundary } from './error-boundary';
import { CustomerMetricsProvider } from './providers/customer-metrics';
import '@moniebook-web/mini-app/index.css';

import { COOKIE_KEYS } from '@moniebook-web/types';

import { MICRO_FRONTENDS } from './mfes';

const telemetry = getTelemetry({
    hostVersion: __HOST_VERSION__,
    mfeManifest: MICRO_FRONTENDS,
    getContext() {
        return {
            businessId: getItem(COOKIE_KEYS.CURRENT_BUSINESS_KEY),
            userId: getItem(COOKIE_KEYS.CURRENT_BUSINESS_USER_KEY),
        };
    },
});

export function App() {
    useEffect(() => {
        telemetry?.metrics.setupWebVitals();
        telemetry?.tracing.setup();
    }, []);

    return (
        <ErrorBoundary>
            <ClientProvider>
                <CustomerMetricsProvider
                    cxMetricsOptions={{
                        appEnv: config.CUSTOMER_ANALYTICS_ENVIRONMENT,
                        applicationID: config.APPLICATION_ID,
                        baseAPIEndpoint: config.CUSTOMER_ANALYTICS_SERVICE,
                        platform: 'web',
                        sdkConfigurations: {
                            mixpanel: config.MIXPANEL.token
                                ? config.MIXPANEL
                                : undefined,
                        },
                    }}>
                    <RouterProvider router={createBrowserRouter(appRoutes)} />
                </CustomerMetricsProvider>
                <Toaster
                    position='top-center'
                    icons={{
                        success: <CheckboxCircleFill />,
                        info: <Information2Fill />,
                        error: <AlertFill />,
                        warning: <AlertFill />,
                    }}
                    toastOptions={{
                        className: 'sonner-toast',
                        classNames: {
                            error: 'sonner_error',
                            success: 'sonner_success',
                            warning: 'sonner_warning',
                            info: 'sonner_info',
                            title: 'sonner_title',
                            content: 'sonner_content',
                            actionButton: 'sonner_action',
                        },
                    }}
                />
            </ClientProvider>
        </ErrorBoundary>
    );
}

// biome-ignore lint/style/noDefaultExport: pre-existing default export, not yet migrated to a named export
export default App;
